import { MouseEventHandler, useCallback, useEffect } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { useToggle } from 'react-use';

import type { FormValues } from '../composeEmailModal.types';

type UseCcBccOptions = {
  initialCcEnabled: boolean;
  initialBccEnabled: boolean;
  setValue: UseFormSetValue<FormValues>;
};

type UseCcBccResult = {
  ccEnabled: boolean;
  bccEnabled: boolean;
  ccOnClick: MouseEventHandler<HTMLButtonElement>;
  bccOnClick: MouseEventHandler<HTMLButtonElement>;
};

export function useCcBcc({
  initialCcEnabled,
  initialBccEnabled,
  setValue,
}: UseCcBccOptions): UseCcBccResult {
  const [ccEnabled, toggleCC] = useToggle(initialCcEnabled);
  const [bccEnabled, toggleBCC] = useToggle(initialBccEnabled);

  useEffect(() => {
    if (!ccEnabled) setValue('cc', []);
  }, [ccEnabled, setValue]);

  useEffect(() => {
    if (!bccEnabled) setValue('bcc', []);
  }, [bccEnabled, setValue]);

  const ccOnClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggleCC();
    },
    [toggleCC],
  );

  const bccOnClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggleBCC();
    },
    [toggleBCC],
  );

  return { ccEnabled, bccEnabled, ccOnClick, bccOnClick };
}
